<div class="page-header">
  <h1 class="direct-report-header">
    {{profileusername}}'s Direct Report(s) Managing Section

  </h1>
  <a (click) ="backtoprofile()" >
    Back
  </a>
</div>
<div class="page">

  <fieldset class="mat-like-fieldset">
    <legend class="mat-like-legend">
      Search Employee
    </legend>
    <div class="white-box">
      <form [formGroup]="userInfoForm">
        <!-- Row: Username + Division + Section (wraps on small screens) -->
        <div class="form-row">
          <!-- Username -->
          <mat-form-field appearance="outline" class="equal">
            <mat-label>Enter Employee Name</mat-label>
            <input
              type="text"
              matInput
              (input)="search($any($event.target).value)"
              [matAutocomplete]="auto"
              formControlName="userName"
              aria-autocomplete="list" />

              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayItem"
                (optionSelected)="onSuggestionChanged($event)">
                @for (_user of users$ | async; track _user) {
                  <mat-option [value]="_user">
                    {{ _user.firstName }} {{ _user.lastName }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            <!-- Division -->
            <mat-form-field appearance="outline" class="equal">
              <mat-label>Select Division</mat-label>
              <mat-select formControlName="divisionCtrl"  [disabled]="isSupervisor && !isDeveloper && !isAdmin">
                @for (division of divisions; track division) {
                  <mat-option [value]="division.ID">
                    {{ division.Name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <!-- Section -->
            <mat-form-field appearance="outline" class="equal">
              <mat-label>Search Section</mat-label>

              <input
                type="text"
                matInput
                (input)="searchSectionItem($any($event.target).value)"
                [matAutocomplete]="autoSection"
                formControlName="sectionCtrl"
                aria-autocomplete="list" />

                <mat-autocomplete
                  #autoSection="matAutocomplete"
                  [displayWith]="displaySection"
                  (optionSelected)="onSectionSuggestionChanged($event)">
                  @for (i of sectiolist$ | async; track i) {
                    <mat-option [value]="i">
                      {{ i.Name }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <!-- Buttons: always on the SAME LINE (no wrap) -->
            <div class="button-row">
              <button
                mat-button
                matTooltip="Search"
                id="btnSave"
                class="regular-button"
                type="button" (click) ="searchUsers()"
                >
                Search <mat-icon>search</mat-icon>
              </button>

              <button
                mat-button
                matTooltip="Reset"
                id="btnCancel"
                class="regular-button"
                type="button" (click) ="clearSearchMode()"
                >
                Reset
              </button>
              @if (loading) {
                <div class="overlay">
                  <mat-spinner class="my-black-spinner"></mat-spinner>
                </div>
              }
            </div>
          </form>
        </div>
      </fieldset>
      @if (this.searchMode==false) {
        <fieldset class="mat-like-fieldset">
          <legend class="mat-like-legend">
            Direct Reports
          </legend>
          <div #searchresults class="user-directory">
            <div style="display: flex;">
              <button
                mat-button
                matTooltip="Assign/Revoke Telework" [disabled] ="!teleworkButtonEnable"
                id="btnAssignTelework"
                class="regular-button"
                type="button" (click) ="SaveRevokeTelework()"
                >
                Assign/Revoke Telework
              </button>
              &nbsp;&nbsp;&nbsp; <button mat-button  matTooltip="Onboard New Hire" id="btnOnBoardNewHire"
            class="regular-button"  type="button" (click) ="OnBoardNewHire()">Onboard New Hire </button>
          </div>
          <br><br>
          <div class="user-grid">
            @for (user of userList; track user) {
              <article class="user-card">
                <!-- Header: Photo + Info -->
                <div class="user-card__header">
                  <div class="user-card__photo">
                    @if (user.photoSafe) {
                      <img
                        [src]="user.photoSafe"
                        alt="User Profile Picture for {{ user.name }}"
                        class="user-card__photo-img"
                        />
                    }
                    @if (!user.photoSafe) {
                      <img
                        src="assets/images/logo_and_icons/empty_portrait_white_small.png"
                        alt="Defaultrd__name">
                    }{{ user.name }}</div>
                    <div class="user-card__title" > <a  (click)="onUserInProfileSelect(user.id!)">{{ user.name }}</a> | {{ user.jobTitle }}</div>
                    <div class="user-card__division">
                      {{ user.division }} <span class="user-card__separator"><br></span> {{ user.section }}
                    </div>
                  </div>
                  @if (user.email) {
                    <div class="user-card__contact">
                      <span class="user-card__contact-item">
                        <mat-icon class="user-card__contact-icon" color="primary">email</mat-icon>
                        <a href="mailto:{{user.email}}">{{user.email}}</a>
                        <mat-checkbox    [checked]="user.hasTelework" class="user-card__checkbox" (change)="onTeleworkChange(user, $event.checked)">
                          <mat-icon aria-label="Telework" matTooltip="Select Telework" class="telework_section-icon telework_telework-icon">
                            home_work
                          </mat-icon>
                        </mat-checkbox>
                        <button  class="user-card__delete" mat-icon-button matTooltip="Remove from direct reports" (click)="onDeletingDirectReport(user)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </span>
                    </div>
                  }
                </article>
              }
            </div>
          </div>
        </fieldset>
      }
      @if (this.searchMode==true) {
        <fieldset class="mat-like-fieldset">
          <legend class="mat-like-legend">
            Search Result(s)
          </legend>
          <div #searchresults class="user-directory">
            <div class="user-grid">
              @for (user of searchEmployeeList; track user) {
                <article class="user-card">
                  <!-- Header: Photo + Info -->
                  <div class="user-card__header" (click)="onUserInProfileSelect(user.id!)">
                    <div class="user-card__photo">
                      @if (user.photoSafe) {
                        <img
                          [src]="user.photoSafe"
                          alt="User Profile Picture for {{ user.name }}"
                          class="user-card__photo-img"
                          />
                      }
                      @if (!user.photoSafe) {
                        <img
                          src="assets/images/logo_and_icons/empty_portrait_white_small.png"
                          alt="Defaultrd__name" >
                      }
                    </div>
                    <div class="user-card__title"> <a  (click)="onUserInProfileSelect(user.id!)">{{ user.name }}</a> | {{ user.jobTitle }}</div>
                    <div class="user-card__division">
                      {{ user.division }} <span class="user-card__separator"><br></span> {{ user.section }}
                    </div>
                  </div>
                  @if (user.email) {
                    <div class="user-card__contact">
                      <span class="user-card__contact-item">
                        <mat-icon class="user-card__contact-icon" color="primary">email</mat-icon>
                        <a href="mailto:{{user.email}}">{{user.email}}</a>
                        @if (this.supervisorid !=user.supervisorid && this.supervisorid != user.id) {
                          <button  class="user-card__assign" mat-icon-button matTooltip="Add {{ user.name}} as Direct Report" (click)="AddThisUserAsDirectReport(user)">
                            <mat-icon>person_add</mat-icon>
                          </button>
                        }
                        @if (this.supervisorid ==user.supervisorid) {
                          <button  class="user-card__assign" mat-icon-button matTooltip="Remove from direct reports" (click)="onDeletingDirectReport(user)">
                            <mat-icon>delete_outline</mat-icon>
                          </button>
                        }
                      </span>
                    </div>
                  }
                </article>
              }
            </div>
          </div>
        </fieldset>
      }
    </div>

